
    import React from 'react';
    import { dynamic } from 'dumi';
    import { Link, AnchorLink, context } from 'dumi/theme';
    import Previewer from 'dumi-theme-mobile/es/builtins/Previewer.js';
import Alert from 'dumi-theme-default/es/builtins/Alert';
import API from 'dumi-theme-default/es/builtins/API';
import Badge from 'dumi-theme-default/es/builtins/Badge';
import Example from 'dumi-theme-default/es/builtins/Example';
import SourceCode from 'dumi-theme-default/es/builtins/SourceCode';
import Tree from 'dumi-theme-default/es/builtins/Tree';
import Table from 'dumi-theme-default/es/builtins/Table';

    // memo for page content, to avoid useless re-render since other context fields changed
    const PageContent = React.memo(({ demos: DUMI_ALL_DEMOS }) => {
      const DumiDemo1 = DUMI_ALL_DEMOS['input-demo'].component

      return (
        <>
          
          <React.Fragment><div className="markdown"><h1 id="input-输入"><AnchorLink to="#input-输入" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>Input 输入</h1>
<p>表单中的输入框组件</p>
<h3 id="代码演示"><AnchorLink to="#代码演示" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>代码演示</h3>
</div><Previewer {...DUMI_ALL_DEMOS['input-demo'].previewerProps}><DumiDemo1 /></Previewer>
<div className="markdown"><h3 id="input-api"><AnchorLink to="#input-api" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>Input API</h3>





























































































































<Table><thead><tr><th>参数</th><th>说明</th><th>类型</th><th>默认值</th></tr></thead><tbody><tr><td>type</td><td>输入框类型, 可选值为 tel digit number textarea password 等,对 Input.TextArea 无效</td><td>string</td><td>-</td></tr><tr><td>value</td><td>input 的值</td><td>string</td><td>-</td></tr><tr><td>minLength</td><td>最少长度</td><td>number</td><td>-</td></tr><tr><td>maxLength</td><td>最多长度</td><td>number</td><td>-</td></tr><tr><td>placeholder</td><td>input 的占位符</td><td>string</td><td>-</td></tr><tr><td>disabled</td><td>是否能点击</td><td>boolean</td><td>-</td></tr><tr><td>readOnly</td><td>是否只读</td><td>boolean</td><td>-</td></tr><tr><td>align</td><td>输入框对齐方式，可选值为 center right，对 Input.TextArea 无效</td><td>string</td><td><code>left</code></td></tr><tr><td>clearable</td><td>是否启用清除图标，点击清除图标后会清空输入框</td><td>boolean</td><td><code>false</code></td></tr><tr><td>clearIcon</td><td>自定义清除图标</td><td>ReactNode</td><td><code>&lt;IconCircleDelete /&gt;</code></td></tr><tr><td>autoFocus</td><td>是否自动聚焦，iOS 系统不支持该属性</td><td>boolean</td><td><code>false</code></td></tr><tr><td>prefix</td><td>插入前置内容， 对 Input.TextArea 无效</td><td>ReactNode</td><td>-</td></tr><tr><td>suffix</td><td>插入后置内容， 对 Input.TextArea 无效</td><td>ReactNode</td><td>-</td></tr><tr><td>onChange</td><td>input 中的 value 改变时触发</td><td>var:string</td><td>-</td></tr><tr><td>onFocus</td><td>获取焦点时的事件</td><td>event: MouseEvent</td><td>-</td></tr><tr><td>onBlur</td><td>失去焦点时的事件</td><td>event: MouseEvent</td><td>-</td></tr><tr><td>onClear</td><td>点击清除按钮时触发</td><td>event: MouseEvent</td><td>-</td></tr><tr><td>onOverlimit</td><td>当输入值超出 maxLength 时触发</td><td>function</td><td>-</td></tr><tr><td>onClick</td><td>点击 Input 时触发</td><td>event: MouseEvent</td><td>-</td></tr></tbody></Table>
<h3 id="inputtextarea-api"><AnchorLink to="#inputtextarea-api" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>Input.Textarea API</h3>
<p>基于 Input, Input 有的参数它都有</p>

















<Table><thead><tr><th>参数</th><th>说明</th><th>类型</th><th>默认值</th></tr></thead><tbody><tr><td>rows</td><td>文本行数</td><td>number</td><td>2</td></tr></tbody></Table>
<h3 id="inputkeyboard-api"><AnchorLink to="#inputkeyboard-api" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>Input.Keyboard API</h3>
<p>基于 base，base 有的参数它都有</p>





















































<Table><thead><tr><th>参数</th><th>说明</th><th>类型</th><th>默认值</th></tr></thead><tbody><tr><td>value</td><td>值</td><td>string</td><td>-</td></tr><tr><td>placeholder</td><td>占位符</td><td>string</td><td>-</td></tr><tr><td>active</td><td>选中时</td><td>boolean</td><td>-</td></tr><tr><td>maxLength</td><td>最多长度</td><td>number</td><td>-</td></tr><tr><td>onChange</td><td>数据改变时的回调</td><td>function</td><td>-</td></tr><tr><td>onClearValue</td><td>点击清除时的回调</td><td>function</td><td>-</td></tr><tr><td>onHandleFocus</td><td>点击选中时的回调</td><td>function</td><td>-</td></tr></tbody></Table></div></React.Fragment>
        </>
      );
    })

    export default (props) => {
      const { demos } = React.useContext(context);

      // scroll to anchor after page component loaded
      React.useEffect(() => {
        if (props?.location?.hash) {
          AnchorLink.scrollToAnchor(decodeURIComponent(props.location.hash.slice(1)));
        }
      }, []);

      return <PageContent demos={demos} />;
  }